import { Controller } from "@hotwired/stimulus"

// Pide el stream del endpoint y deja que Turbo lo aplique: el servidor decide qué cambia en la
// lista (fila fuera, cupo, flash) y también cuándo no cambia nada (cupo lleno: 422 con el aviso).
// Doc: _docs/features/products/partner_products_index.md
export default class extends Controller {
  static targets = ["dialog", "name", "confirm", "cancel"]

  connect() {
    // El snapshot de Turbo se toma antes del disconnect: no cachear el sheet abierto
    this.beforeCache = () => this.close()
    document.addEventListener("turbo:before-cache", this.beforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache)
  }

  // Toast cuando el servidor no respondió con un stream; cada subclase pone el suyo
  get errorMessage() {
    return "No se pudo completar la acción. Inténtalo de nuevo."
  }

  open(event) {
    const { name, url, row } = event.detail
    this.url = url
    this.row = row
    this.nameTarget.textContent = name
    if (!this.dialogTarget.open) this.dialogTarget.showModal()
  }

  close() {
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  // El click fuera del panel llega al propio <dialog> (su ::backdrop)
  backdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  // Al cerrar (Cancelar, Esc, backdrop, confirmado) la fila queda como estaba: el navegador devuelve
  // el foco al botón de la acción y, si la fila se cerrara aquí, el foco caería en un control invisible.
  // Con éxito el stream quita la fila; con error o aviso, sigue abierta para reintentar.
  reset() {
    this.url = null
    this.row = null
  }

  // Cualquier respuesta turbo-stream (200 o 422) es la palabra del servidor y se aplica tal cual;
  // otra cosa (red caída, redirect al login, 500) es un error y la fila queda para reintentar.
  async confirm() {
    if (!this.url) return
    this.#pending(true)
    try {
      const response = await fetch(this.url, {
        method: "PUT",
        headers: { "Accept": "text/vnd.turbo-stream.html", "X-CSRF-Token": csrfToken() }
      })
      if (!isTurboStream(response)) throw new Error(`HTTP ${response.status}`)
      Turbo.renderStreamMessage(await response.text())
    } catch (error) {
      console.error(this.errorMessage, error)
      window.toastr?.error(this.errorMessage)
    } finally {
      this.#pending(false)
      this.close()
    }
  }

  #pending(on) {
    this.dialogTarget.classList.toggle("is-pending", on)
    this.confirmTarget.disabled = on
    this.cancelTarget.disabled = on
  }
}

function isTurboStream(response) {
  return (response.headers.get("Content-Type") || "").includes("text/vnd.turbo-stream.html")
}

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content
}
